import { createSelector } from "reselect"
import { initialState } from "./reducer"

/**
 * Direct selector to the account state domain
 */

const selectAccountDomain = (state) => state.get("account", initialState)

/**
 * Other specific selectors
 */
export const makeSelectOptionsSelect = () =>
  createSelector(selectAccountDomain, (state) => state.get("optionsSelect"))

export const makeSelectIsLoadingOptionsSelect = () =>
  createSelector(selectAccountDomain, (state) =>
    state.get("isLoadingOptionsSelect")
  )

export const makeSelectInfoCompany = () =>
  createSelector(selectAccountDomain, (state) => state.get("infoCompany"))

export const makeSelectIsLoadingInfoCompany = () =>
  createSelector(selectAccountDomain, (state) =>
    state.get("isLoadingInfoCompany")
  )
/**
 * Default selector used by Account
 */

const makeSelectAccount = () =>
  createSelector(selectAccountDomain, (substate) => substate.toJS())

export default makeSelectAccount
export { selectAccountDomain }
